import { buildWidget } from './table-view';

require('./fact-widget.component.scss');

export function FactsWidgetComponent($compile) {
  return {
    restrict  : 'E',
    scope     : {
      model    : '<',
      filter   : '<',
      fact     : '<',
      showImage: '<',
      listType : '<',
    },
    controller: function ($scope, $element) {
      $scope.isCollapsed = $scope.listType === 'full';
      $scope.collapse = function () {
        $scope.isCollapsed = !$scope.isCollapsed;
        if ($scope.isCollapsed) {
          $element.addClass('collapsed');
        } else {
          $element.removeClass('collapsed');
        }
      };
      $scope.collapse();

    },
    link      : function (scope, element, attrs) {
//                 console.log('Linking eventWidget for '+scope.fact.id);
      if (!scope.showImage) {
        scope.showImage = () => {
        };
      }
      let widget = buildWidget(scope.fact);
      element.append(widget);
      $compile(element.contents())(scope);
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-widget.component.js